import {
  BULK_EMAILING_FEATURE,
  BULK_TOUCHPOINTS_FEATURE,
  BULK_TOUCHPOINTS_SMS_MESSAGES,
  CALL_BACK_LIST_FEATURE,
  CUSTOM_CAMPAIGNS_FEATURE,
  GOOGLE_REVIEW_REQUESTS_REPORT_FEATURE,
  MARKETING_DASHBOARD_FEATURE,
  PHYSICIAN_MARKETING_FEATURE
} from "constants/feature-flags";

import type { DestinationAccess } from "./destination.types";
import inSection, { DestinationRow } from "./in-section.util";

// The Call Back List opens Marketing to all staff; every other page keeps the
// section's original audience.
const canSeeMarketingTabs = ({ roles }: DestinationAccess) =>
  roles.canAccessCampaigns || roles.isAdminOrBusinessOwner;

const MARKETING_TABS: DestinationRow[] = [
  {
    to: "dashboard",
    label: "Dashboard",
    featureFlag: MARKETING_DASHBOARD_FEATURE
  },
  {
    to: "review-requests",
    label: "Review Requests",
    featureFlag: GOOGLE_REVIEW_REQUESTS_REPORT_FEATURE
  },
  { to: "touchpoints", label: "Touchpoints" },
  {
    to: "touchpoints/my",
    label: "Assigned Touchpoints",
    trail: ["Touchpoints"]
  },
  {
    to: "touchpoints/bulk",
    label: "Bulk Touchpoints",
    trail: ["Touchpoints"],
    featureFlag: BULK_TOUCHPOINTS_FEATURE
  },
  {
    to: "touchpoints/bulk-actions",
    label: "Bulk SMS Actions",
    trail: ["Touchpoints"],
    featureFlag: BULK_TOUCHPOINTS_SMS_MESSAGES
  },
  { to: "campaigns", label: "Campaigns" },
  {
    to: "custom-campaigns",
    label: "Custom Campaigns",
    featureFlag: CUSTOM_CAMPAIGNS_FEATURE
  },
  {
    to: "bulk-email",
    label: "Bulk Emailing",
    featureFlag: BULK_EMAILING_FEATURE
  },
  {
    to: "physician-marketing",
    label: "Physician Marketing",
    featureFlag: PHYSICIAN_MARKETING_FEATURE
  }
].map((row) => ({ ...row, when: canSeeMarketingTabs }));

export const MARKETING_DESTINATIONS = inSection("/marketing", [
  ...MARKETING_TABS,
  {
    to: "call-back-list",
    label: "Call Back List",
    featureFlag: CALL_BACK_LIST_FEATURE
  }
]);
